// extracted by mini-css-extract-plugin
export var active = "_kw-e";
export var blink = "_kw-f";
export var dropDownSelector = "_kw-5";
export var dropDownWrapper = "_kw-4";
export var fakeCursor = "_kw-d";
export var fontSizeButton = "_kw-7";
export var formQuillEditor = "_kw-0";
export var pressed = "_kw-g";
export var qlBlank = "_kw-1";
export var textFormattingToolbar = "_kw-2";
export var textFormattingToolbarClosed = "_kw-3";
export var textFormattingToolbarInline = "_kw-6";
export var textToolbarOption = "_kw-8";
export var toolbarCell = "_kw-a";
export var toolbarCellCollapsed = "_kw-b";
export var toolbarOptionHitArea = "_kw-c";
export var toolbarOverflow = "_kw-9";